import React from 'react';
import { Avatar, Card, Space, Typography, theme } from 'antd';
import { JudgeType } from '@vote4dance/judging-schema';
import { AuditOutlined, CheckOutlined, CrownOutlined, StopOutlined } from '@ant-design/icons';
import { _T } from '../../../../../base-react/src/Localization';
const { useToken } = theme;
export const JudgeTypeLegend = () => {
    const { token } = useToken();
    const judgeTypes = ['none', JudgeType.Normal, JudgeType.Trainee, JudgeType.ChiefIn, JudgeType.ChiefOut];
    const judgeTypeIcons = {
        none: React.createElement(StopOutlined, null),
        normal: React.createElement(CheckOutlined, null),
        trainee: React.createElement(AuditOutlined, null),
        'chief-in': React.createElement(CrownOutlined, null),
        'chief-out': React.createElement(CrownOutlined, null)
    };
    const judgeTypeInfo = judgeTypes.map((type) => ({
        key: type,
        title: _T(`judges.type.${type}.title`),
        desc: _T(`judges.type.${type}.desc`),
        icon: judgeTypeIcons[type],
        color: type === 'none'
            ? token.colorTextDisabled
            : type === 'normal'
                ? token.colorPrimary
                : type === 'trainee'
                    ? token.colorWarning
                    : type === 'chief-in'
                        ? token.colorInfo
                        : type === 'chief-out'
                            ? token.colorError
                            : token.colorSuccess
    }));
    return (React.createElement(Card, { size: "small", variant: "borderless", styles: { body: { padding: 8 } } },
        React.createElement(Space, { orientation: "vertical", size: 4, style: { width: '100%' } },
            React.createElement(Space, { size: "small", orientation: "vertical", style: { width: '100%' } }, judgeTypeInfo.map(info => (React.createElement(Space, { key: info.key, size: "small" },
                React.createElement(Avatar, { size: "small", icon: info.icon, style: { backgroundColor: token.colorBgContainer, color: info.color } }),
                React.createElement(Typography.Text, { strong: true }, info.title),
                React.createElement(Typography.Text, { type: "secondary" }, info.desc))))))));
};
